import React, { useState, useEffect } from "react";
import {
  BaseButtons,
  TextInputField,
  TextInputFieldArea,
} from "../../../../../common-components";
import { colors } from "../../../../../../themes/Colors";
import ImageUploadAWS from "../../../../../user/components/image-upload/ImageUploadAWS";
import useWindowDimensions from "../../../../../../dynamic-sizing-functions/get-diemensions/UseWindowDiemensions";
import { CategoryPopUp } from "./components";
import AWS from "aws-sdk";

const validFileTypes = ["image/jpg", "image/jpeg", "image/png"];
const CreateProductModal = ({
  display,
  setCreatePostModal,
  refresh,
  setRefresh,
  setLoading,
  auth,
  setMessage,
  setToastPop,
  setPopUpTitle,
  companyInformation,
  typeCheck,
}) => {
  const { width, height } = useWindowDimensions();
  const [imageData, setImageData] = useState(null);
  const [previewImage, setPreviewImage] = useState(null);

  const [file, setFile] = useState(null);

  const [imageError, setImageError] = useState("");

  const handleFileChange = (e) => {
    // Uploaded file
    const file = e.target.files[0];
    // Changing file state
    setFile(file);
  };

  const [productName, setproductName] = useState("");
  const [alternateName, setAlternateName] = useState("");
  const [keyWords, setKeyWords] = useState("");
  const [tags, setTags] = useState("");
  const [knownAs, setKnownAs] = useState("");
  const [brand, setBrand] = useState("");

  const [category, setCategory] = useState(null);

  const [categoryPopUp, setCategoryPopUp] = useState(false);

  const [shortDescription, setShortDescription] = useState("");
  const [productDescription, setProductDescription] = useState("");
  const [specificationsDescription, setSpecificationDescription] = useState("");
  const [productUseDescription, setProductUseDescription] = useState("");

  const [imagelink, setImageLink] = useState("");

  const CreateNewProduct = async (e) => {
    setLoading(true);

    // if (!validFileTypes.find((type) => type === file.type)) {
    //   setImageError("File type must be JPG or PNG format");
    //   setLoading(false);
    //   return;
    // } else {
    //   setImageError("");
    //   setLoading(false);
    //   setImageData(file);
    // }
    try {
      const formData = new FormData();
      formData.append("image", file);
      formData.append("productName", productName);
      formData.append("BussinessId", companyInformation._id);
      formData.append("BussinessName", companyInformation.companyName);
      formData.append("createdOn", new Date().toLocaleString());
      formData.append("createdBy", auth.firstName + " " + auth.lastName);
      formData.append("editedOn", new Date().toLocaleString());
      formData.append("alternateName", alternateName);
      formData.append("keyWords", keyWords);
      formData.append("tags", tags);
      formData.append("brand", brand);
      formData.append("category", category.categoryName);
      formData.append("categoryId", category._id);

      formData.append("shortDescription", shortDescription);
      formData.append("price", knownAs);
      formData.append("productDescription", productDescription);
      formData.append("specificationDescription", specificationsDescription);
      formData.append("productUseDescription", productUseDescription);

      const response = await fetch(
        "https://driverfrienddatabase-h2aa.onrender.com" +
          "/catalogue/createProduct",
        {
          method: "POST",
          body: formData,
        }
      );
      const respnseData = await response.json();

      if (respnseData.success) {
        setCreatePostModal(false);
        setToastPop(true);
        setMessage(respnseData.success);
        setPopUpTitle("SUCCESS");
        setLoading(false);
        setRefresh(refresh ? false : true);
        //   ClearData();
        // setVehicleSearchArray(respnseData.enatisVehicles);
      } else {
        setToastPop(true);
        setMessage(respnseData.message);
        setPopUpTitle("FAILURE");
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  const getUplaodImage = async () => {
    const S3_BUCKET = process.env.REACT_APP_BUCKET;
    const apiKey = process.env.REACT_APP_AWS_ACCESS_KEY_ID;
    const secrectapiKey = process.env.REACT_APP_AWS_SECRET_KEY_ID;
    AWS.config.update({
      accessKeyId: apiKey,
      secretAccessKey: secrectapiKey,
    });
    const s3 = new AWS.S3({
      params: { Bucket: S3_BUCKET },
      region: process.env.REACT_APP_REGION,
      signatureVersion: "v4",
    });

    const params = {
      Bucket: S3_BUCKET,
      Key: display.imageId,
    };

    var promise = s3.getSignedUrlPromise("getObject", params);
    // return promise;
    promise.then(
      function (url) {
        if (url) {
          setImageLink(url);
        }
        return url;
      },
      function (err) {
        console.log(err);
      }
    );
  };
  useEffect(() => {
    if (display) {
      getUplaodImage();
    }
  }, [display]);

  useEffect(() => {
    if (!file) {
      //   if (!sigfile) {
      //     return;
      //   }
      return;
    }
    const fileReader = new FileReader();
    fileReader.onload = () => {
      setPreviewImage(fileReader.result);
    };
    fileReader.readAsDataURL(file);
  }, [file]);
  useEffect(() => {
    if (typeCheck === "edit" && display) {
      console.log("set all data");
      setproductName(display.productName);
      setAlternateName(display.alternateName);
      setKeyWords(display.keyWords);
      setTags(display.tags);
      setKnownAs(display.price);
      setBrand(display.brand);
      setShortDescription(display.shortDescription);
      setProductDescription(display.productDescription);
      setCategory({
        categoryName: display.category,
        categoryId: display.categoryId,
      });
      setSpecificationDescription(display.specificationDescription);
      setProductUseDescription(display.productUseDescription);
    }
  }, [display]);
  return (
    <div
      style={{
        position: "absolute",
        bottom: 0,
        height: display ? "100%" : 0,
        width: "100%",
        backgroundColor: colors.white,
        overflow: "hidden",
        display: "flex",
        flexDirection: "row",
        justifyContent: "flex-start",
        alignItems: "center",
        transition: "all 0.3s",
        zIndex: 300,
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 10,
          left: 10,
          display: "flex",
          alignItems: "center",
        }}
      >
        <BaseButtons
          label={"X"}
          borderRadius={8}
          backgroundColor={colors.secondaryDarkBlue}
          width={40}
          onClick={() => {
            setCreatePostModal(typeCheck === "edit" ? null : false);
            // ClearData();
          }}
        />
        <div style={{ fontWeight: "bold", fontSize: 18, marginLeft: 10 }}>
          ADD NEW PRODUCT
        </div>
      </div>
      <div
        style={{
          position: "absolute",
          top: 10,
          right: 10,
          display: "flex",
          alignItems: "center",
        }}
      >
        {typeCheck === "edit" ? (
          <>
            <BaseButtons
              label={"UPDATE"}
              borderRadius={8}
              backgroundColor={colors.secondaryDarkBlue}
              width={140}
              //   onClick={() => {
              //     setCreatePostModal(false);
              //     // ClearData();
              //   }}
            />
            <div style={{ minWidth: 20 }} />
            <BaseButtons
              label={"DELETE"}
              borderRadius={8}
              backgroundColor={colors.secondaryDarkBlue}
              width={140}
              //   onClick={() => {
              //     setCreatePostModal(false);
              //     // ClearData();
              //   }}
            />
          </>
        ) : (
          <BaseButtons
            label={"SUBMIT"}
            borderRadius={8}
            backgroundColor={colors.secondaryDarkBlue}
            width={140}
            onClick={() => {
              CreateNewProduct();
              // ClearData();
            }}
          />
        )}
      </div>
      <div
        style={{
          //   flex: 0.5,
          //   borderStyle: "solid",
          height: "99%",
          //   borderWidth: 1,
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-start",
          alignItems: "flex-start",
          maxHeight: height - 80,
          overflowY: "scroll",
          overflowX: "hidden",
        }}
      >
        <div style={{ marginTop: 80 }}>
          <div style={{ marginLeft: 20, fontWeight: "bold" }}>
            - Basic Product Information ( ALL FILEDS ARE REQUIRED )
          </div>
        </div>
        <div
          style={{
            display: "flex",
            width: "100%",
            minWidth: 650,
            maxWidth: 650,
          }}
        >
          <TextInputField
            labelTitle={"Product Name"}
            mini={true}
            size={"70%"}
            width={"50%"}
            value={productName}
            onChange={(e) => setproductName(e.target.value)}
          />

          <TextInputField
            labelTitle={"Alternate Name"}
            mini={true}
            size={"70%"}
            width={"50%"}
            value={alternateName}
            onChange={(e) => setAlternateName(e.target.value)}
          />
        </div>
        <div style={{ display: "flex" }}>
          <div style={{ marginLeft: 38, marginTop: 20 }}>
            <img
              alt="loading"
              src={
                previewImage
                  ? previewImage
                  : imagelink
                  ? imagelink
                  : previewImage
              }
              style={{
                backgroundColor: "#00000040",
                minHeight: 250,
                minWidth: 250,
                maxHeight: 250,
                maxWidth: 250,
                // marginTop: open ? 50 : null,
              }}
            />
            <ImageUploadAWS
              onChange={(e) => handleFileChange(e)}
              labelTitle={"UPLOAD IMAGE"}
              mini={true}
              errorDisplay={imageError}
            />
          </div>
          <div
            style={{
              minWidth: 320,
              //   marginLeft: 20,
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-end",
              //   borderStyle: "solid",
              justifyContent: "space-between",
            }}
          >
            <div style={{ minHeight: 5 }} />
            <TextInputField
              labelTitle={"Key words"}
              mini={true}
              size={"90%"}
              width={"76%"}
              value={keyWords}
              onChange={(e) => setKeyWords(e.target.value)}
            />
            <TextInputField
              labelTitle={"Tags"}
              mini={true}
              size={"90%"}
              width={"76%"}
              value={tags}
              onChange={(e) => setTags(e.target.value)}
            />
            <TextInputField
              labelTitle={"Price"}
              mini={true}
              size={"90%"}
              width={"76%"}
              value={knownAs}
              type={"number"}
              onChange={(e) => setKnownAs(e.target.value)}
            />
            <TextInputField
              labelTitle={"Brand"}
              mini={true}
              size={"90%"}
              width={"76%"}
              value={brand}
              onChange={(e) => setBrand(e.target.value)}
            />
          </div>
        </div>
        <div>
          <div style={{ marginLeft: 20, fontWeight: "bold", marginTop: 20 }}>
            - SELECT CATEGORY
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginTop: 20,
            marginBottom: 20,
          }}
        >
          <BaseButtons
            borderRadius={4}
            label={category ? category.categoryName : "SELECT CATEGORY"}
            onClick={() => setCategoryPopUp(true)}
            backgroundColor={colors.primaryBlue}
            width={"80%"}
          />
        </div>

        {categoryPopUp ? (
          <CategoryPopUp
            setCategory={setCategory}
            setClose={setCategoryPopUp}
            auth={auth}
            companyInformation={companyInformation}
          />
        ) : null}
      </div>
      <div
        style={{
          flex: 1,
          //   borderStyle: "solid",
          height: "99%",
          borderWidth: 1,
          maxHeight: height - 80,
          overflowY: "scroll",
          overflowX: "hidden",
          maxWidth: 650,
        }}
      >
        <div style={{ marginTop: 80 }}>
          <div style={{ marginLeft: 20, fontWeight: "bold" }}>
            - Description and Extra Information ( This is optional )
          </div>
        </div>
        <TextInputFieldArea
          labelTitle={"Short description (Max length 100)"}
          mini={true}
          height={100}
          count={true}
          size={"90%"}
          value={shortDescription}
          onChange={(e) => setShortDescription(e.target.value)}
        />
        <TextInputFieldArea
          labelTitle={"Product description"}
          mini={true}
          height={100}
          count={true}
          size={"90%"}
          value={productDescription}
          onChange={(e) => setProductDescription(e.target.value)}
        />
        <TextInputFieldArea
          labelTitle={"Specifications description"}
          mini={true}
          height={100}
          count={true}
          size={"90%"}
          value={specificationsDescription}
          onChange={(e) => setSpecificationDescription(e.target.value)}
        />
        <TextInputFieldArea
          labelTitle={"Product use description"}
          mini={true}
          height={100}
          count={true}
          size={"90%"}
          value={productUseDescription}
          onChange={(e) => setProductUseDescription(e.target.value)}
        />
      </div>
    </div>
  );
};

export default CreateProductModal;
